<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
<!--
                            <img style="max-width: 400px; width: 400px; height: 230px; max-height: 230px" src="@/assets/images/landing.jpeg" alt="login" class="mx-auto">
-->
                            <img style="max-width: 400px; width: 400px; height: 230px; max-height: 230px" src="@/assets/images/landing_mtn.jpg" alt="login" class="mx-auto">
                        </div>
                        <div v-if="status == '0'" class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Réinitialiser le mot de passe</h4>
                                    <p>
                                        Veuillez saisir votre adresse e-mail et nous vous enverrons des instructions pour réinitialiser votre mot de passe.
                                    </p>
                                </div>

                                <vs-input type="email" label-placeholder="Email" v-model="email" class="w-full mb-8" />
                                <vs-button type="border" to="/login" class="px-4 w-full md:w-auto">Connexion</vs-button>
                                <vs-button @click="verifyEmail()" class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0">Reinitialiser</vs-button>
                            </div>
                        </div>

                      <div v-else-if="status == '1'" class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
                        <div class="p-8">
                          <div class="vx-card__title mb-8">
                            <h4 class="mb-4">Vérification du compte</h4>
                            <p>
                              Veuillez saisir le code que nous vous avions envoyé.
                            </p>
                          </div>

                          <vs-input type="text"
                                    :danger="error_reset.code ? true : false"
                                    :danger-text="error_reset.code ? error_reset.code[0] : ''"
                                    label-placeholder="Code de vérification"
                                    v-model="code" class="w-full mb-8" />
                          <vs-button type="border" to="/login" class="px-4 w-full md:w-auto">Connexion</vs-button>
                          <vs-button @click="verifyCode()" class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0">Vérifier</vs-button>
                        </div>
                      </div>
                      <div v-else class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
                        <div class="p-8">
                          <div class="vx-card__title mb-8">
                            <h4 class="mb-4">Entrer un nouveau mot de passe</h4>
                            <p>
                              Veuillez réinitialiser votre mot de passe en saisisant un nouveau.
                            </p>
                          </div>

                          <vs-input type="password"
                                    :danger="error_reset.password ? true : false"
                                    :danger-text="error_reset.password ? error_reset.password[0] : ''"
                                    label-placeholder="Nouveau mot de passe"
                                    v-model="password" class="w-full mb-8" />
                          <vs-button type="border" to="/login" class="px-4 w-full md:w-auto">Connexion</vs-button>
                          <vs-button @click="resetPassword()" class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0">Reinitialiser</vs-button>
                        </div>
                      </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            email: '',
          error_reset: [],
          status: '0',
          code: '',
          password: '',
        }
    },
    methods:{
      resetPassword(){
        this.$vs.loading()
        this.$http.post('/login/reset-account', {email: this.email, password: this.password}).then((response) =>{
          this.$vs.loading.close()
          window.GETCCMT.success('Votre mot de passe à été réinitialisé', {});
          this.error_reset = []
          this.$router.push('/login')
        }).catch((error) =>{
          if (error.response.status === 422){
            this.error_reset = error.response.data.errors
          }
          this.$vs.loading.close()
        })
      },
      verifyEmail(){
        this.$vs.loading()
        this.$http.post('/login/password-reset', {email: this.email}).then((response) =>{
          this.$vs.loading.close()
          window.GETCCMT.success('Si les informations saisie sont correct, un mail vous sera envoyé', {});
          this.status = '1'
          //localStorage.setItem('reset_email', this.email)
          this.error_reset = []
          //this.email = ''
        }).catch((error) =>{
          if (error.response.status === 422){
            this.error_reset = error.response.data.errors
          }
          this.$vs.loading.close()
        })
      },
      verifyCode(){
        this.$vs.loading()
        this.$http.post('/login/verify-account', {email: this.email, code: this.code}).then((response) =>{
          this.$vs.loading.close()
          window.GETCCMT.success('Vos informations sont corrects', {});
          this.error_reset = []
          this.status = '2'
        }).catch((error) =>{
          if (error.response.status === 422){
            this.error_reset = error.response.data.errors
          }
          this.$vs.loading.close()
        })
      }
    }
}
</script>
